var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle, _path2, _circle2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.45 21.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.79,
    y1: 11.68,
    x2: 21.67,
    y2: 11.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9d63a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 11.73,
    y1: 18.31,
    x2: 11.73,
    y2: 17.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacbcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b6b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a0a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#939494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8e8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39393a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 11.73,
    y1: 17.91,
    x2: 11.73,
    y2: 16.74,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 11.73,
    y1: 7.2,
    x2: 11.73,
    y2: 2.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8f0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#9b0003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b00006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cc000b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f00012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#f20012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7876"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 7.15,
    y1: 3.33,
    x2: 7.15,
    y2: 6.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#870001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7b0003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#660006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4a000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#250010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190012"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 16.3,
    y1: 3.33,
    x2: 16.3,
    y2: 6.26,
    xlinkHref: "#e"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.79,
    y: 3.64,
    width: 19.88,
    height: 16.08,
    rx: 1.37,
    fill: "url(#a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.79,
    y: 3.64,
    width: 19.88,
    height: 15.64,
    rx: 1.35,
    fill: "#f79905"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.44,
    y: 3.64,
    width: 18.58,
    height: 15.15,
    rx: 1.29,
    fill: "#af5320"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.73,
    y: 3.25,
    width: 18,
    height: 15.1,
    rx: 1.27,
    fill: "url(#b)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.73,
    y: 3.25,
    width: 18,
    height: 14.7,
    rx: 1.25,
    fill: "url(#c)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.73,
    y: 3.25,
    width: 18,
    height: 14.33,
    rx: 1.23,
    fill: "#eaeaea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,3.25H19.5a1.23,1.23,0,0,1,1.23,1.23v3a0,0,0,0,1,0,0h-18a0,0,0,0,1,0,0v-3A1.23,1.23,0,0,1,4,3.25Z",
    fill: "url(#d)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92,
    y: 8.83,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.06,
    y: 8.83,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.19,
    y: 8.83,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 8.83,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.92,
    y: 12.88,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8.06,
    y: 12.88,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12.19,
    y: 12.88,
    width: 3.2,
    height: 3.2,
    fill: "#979797"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 12.88,
    width: 3.2,
    height: 3.2,
    fill: "#c6c6c6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.15,
    cy: 5.23,
    r: 1.14,
    fill: "url(#e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91,2.84v2.4A.76.76,0,0,1,7.15,6a.77.77,0,0,1-.77-.76V2.84a.78.78,0,0,1,.77-.77A.77.77,0,0,1,7.91,2.84Z",
    fill: "#f79905"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3,
    cy: 5.23,
    r: 1.14,
    fill: "url(#f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.07,2.84v2.4a.77.77,0,0,1-1.53,0V2.84a.77.77,0,1,1,1.53,0Z",
    fill: "#f79905"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,2.07a.76.76,0,0,1,.77.76v.42H19.5a1.18,1.18,0,0,1,.89.4A1.35,1.35,0,0,1,21.67,5V18.35a1.38,1.38,0,0,1-1.38,1.37H3.16a1.37,1.37,0,0,1-1.37-1.37V5A1.34,1.34,0,0,1,3.06,3.65a1.19,1.19,0,0,1,.9-.4H6.38V2.83a.77.77,0,0,1,.77-.76.76.76,0,0,1,.76.76v.42h7.63V2.83a.76.76,0,0,1,.76-.76m0-.71a1.47,1.47,0,0,0-1.44,1.18H8.59a1.47,1.47,0,0,0-2.89,0H4A2,2,0,0,0,2.74,3,2.08,2.08,0,0,0,1.07,5V18.35a2.09,2.09,0,0,0,2.09,2.08H20.29a2.09,2.09,0,0,0,2.09-2.08V5a2.07,2.07,0,0,0-1.67-2,1.9,1.9,0,0,0-1.21-.43H17.75A1.47,1.47,0,0,0,16.3,1.36Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91,2.84v1H6.38v-1a.78.78,0,0,1,.77-.77A.77.77,0,0,1,7.91,2.84Z",
    fill: "#f5cd38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.07,2.84v1H15.54v-1a.77.77,0,1,1,1.53,0Z",
    fill: "#f5cd38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin1);
export default __webpack_public_path__ + "static/media/checkin_1.a07be3b5.svg";
export { ForwardRef as ReactComponent };